import { Grid } from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";
import { useNavigate } from "react-router-dom";

const InsuranceCompanies = () => {
  const navigate = useNavigate();

  return (
    <Grid container sx={design.Container}>
      <Grid size={design.Grid1} />
      <Grid container size={design.Grid10} py={5}>
        <Grid size={design.Grid12}>
          <CustomText
            variant="subtitle1"
            color="#162E84"
            text="Aseguradoras"
            sx={design.Title}
          >
            Aseguradoras
          </CustomText>
        </Grid>
        {ImgSeguros.map((doc, index) => (
          <Grid key={index} size={design.Grid4} sx={design.Align}>
            <ImageLoader
              src={doc.img}
              alt="nuestros_valores_en_centro-medico_MEDAM"
              width={doc.Width}
              height={doc.Height}
            />
          </Grid>
        ))}
        <Grid size={design.Grid12}>
          <CustomText
            variant="subtitle1"
            color="#2349D0"
            text="Conoce todas nuestras"
            sx={design.Conoce}
            onClick={() => navigate("/aseguradoras")}
          >
            Conoce todas nuestras aseguradoras y convenios{" "}
            <KeyboardArrowRight sx={design.Margin} />
          </CustomText>
        </Grid>
      </Grid>
      <Grid size={design.Grid1} />
    </Grid>
  );
};
export default InsuranceCompanies;

const design = {
  Container: {
    position: "relative",
    overflow: "hidden",
    backgroundImage:
      "url('https://centromedicomedam.com/IMG/centromedicoMEDAM/background_mini_logos_paquetes_del_centro-medico_MEDAM.png')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  Title: {
    fontFamily: "Nunito",
    fontSize: { xs: 30, md: 30, xl: 50, lg: 50 },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: 1,
  },
  Conoce: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    fontFamily: "Nunito",
    fontSize: { xs: 15, md: 30, xl: 20, lg: 20 },
    lineHeight: "normal",
    fontWeight: "bold",
    marginTop: 4,
  },
  Align: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    marginTop: 5,
  },
  Margin: { marginTop: 0.5 },
  Grid1: { xs: 12, md: 2, xl: 2, lg: 2 },
  Grid10: { xs: 12, md: 8, xl: 8, lg: 8 },
  Grid12: { xs: 11, md: 12, xl: 12, lg: 12 },
  Grid4: { xs: 6, md: 4, xl: 4, lg: 4 },
};

const ImgSeguros = [
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_GNP_seguros.png",
    Width: { xs: "100%", md: 262, xl: 262, lg: 262 },
    Height: { xs: 50, md: 71, xl: 71, lg: 71 },
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_AXA.png",
    Width: { xs: "100%", md: 262, xl: 262, lg: 262 },
    Height: { xs: 90, md: 140, xl: 140, lg: 140 },
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Seguros_MetLife.png",
    Width: { xs: "97%", md: 262, xl: 262, lg: 262 },
    Height: { xs: 40, md: 71, xl: 71, lg: 71 },
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Plan_Seguros.svg",
    Width: { xs: "97%", md: 280, xl: 280, lg: 280 },
    Height: { xs: 30, md: 48, xl: 48, lg: 48 },
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Allianz.png",
    Width: { xs: "97%", md: 262, xl: 262, lg: 262 },
    Height: { xs: 80, md: 140, xl: 140, lg: 140 },
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Mapfre.png",
    Width: { xs: "97%", md: 262, xl: 262, lg: 262 },
    Height: { xs: 80, md: 150, xl: 150, lg: 150 },
  },
];
